// React
import { useContext } from "react"

// Components
import { Textarea } from "components"

// Contexts
import { BillContext } from "../contexts"

export function Location(): JSX.Element {
  // Hooks
  const data = useContext(BillContext)

  return (
    <Textarea
      disabled
      label="BRANCH LOCATION"
      value={data.databill.address}
    />
  )
}